import { Reducer } from 'redux'
import { createReducer } from 'reduxsauce'
import { ActiveSearchTypes, IActiveSearchState, IPaginatorModified } from './types'
import { IActionType, success, failure, request } from '../root.types'
import { PotentialPatient } from '../../application/models/potential.patient/potentialPatient'

const INITIAL_STATE: IActiveSearchState = {
    create: {
        activeSearch: new PotentialPatient(),
        loading: false,
        success: false,
        error: false
    },
    list: {
        activeSearches: [],
        loading: false,
        error: false,
        success: false,
        paginator: {
            first: 0,
            rows: 10,
            page: 0,
            pageCount: 0,
            totalRecords: 0,
            search: {
                state: "",
                city: ""
            }
        }
    },
    dialog: false
}

// resetar PAGINADOR salvo no LIST
export const resetPaginator = (state: IActiveSearchState = INITIAL_STATE) => {
    const reset = {
        first: 0,
        rows: 10,
        page: 0,
        pageCount: 0,
        totalRecords: 0,
        search: {
            state: "",
            city: ""
        }

    }
    return {
        ...state,
        list: { ...state.list, paginator: reset }
    }
}
// reducers para mudança de dialog
export const handleDialog = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ dialog: boolean }>) => {
    return { ...state, dialog: action.payload.dialog }
}

// reducers para mudança de dialog
export const storeActiveSearch = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ activeSearch: PotentialPatient }>) => {
    return { ...state, create: { ...state.create, ActiveSearch: action.payload.activeSearch } }
}

// criar novo ActiveSearcho 
export const createActiveSearchRequest = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ activeSearch: PotentialPatient }>) => {
    return { ...state, create: request({ ...state.create }) }
}

export const createActiveSearchSuccess = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ data: PotentialPatient }>) => {
    const { data } = action.payload
    const updateList = [data].concat(state.list.activeSearches)
    return {
        ...state,
        create: success({ ...state.create, activeSearch: data }),
        list: { ...state.list, activeSearches: updateList }
    }
}

export const createActiveSearchFailure = (state: IActiveSearchState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}
// reducers para carregar listagem do active search
export const loadActiveSearchRequest = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ paginator?: IPaginatorModified }>) => {
    const { paginator } = action.payload
    return { ...state, list: request({ ...state.list, paginator }) }
}

export const loadActiveSearchSuccess = (
    state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ data: PotentialPatient[], headers: any }>) => {
    const { data, headers } = action.payload
    const paginator = {
        ...state.list.paginator,
        totalRecords: parseInt(headers['x-total-count'], 10)
    }
    return {
        ...state,
        list: success({
            ...state.list,
            activeSearches: data,
            paginator
        })
    }
}

export const loadActiveSearchFailure = (state: IActiveSearchState = INITIAL_STATE) => {
    return {
        ...state,
        list: failure(state.list)
    }
}


// reducers para procura paciente especifico
export const findActiveSearchRequest = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ activeSearchId: string }>) => {
    return { ...state, create: request({ ...state.create }) }
}
export const findActiveSearchSuccess = (
    state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ data: PotentialPatient }>) => {
    const { data } = action.payload
    return {
        ...state,
        create: success({ ...state.create, activeSearch: data })
    }
}

export const findActiveSearchFailure = (state: IActiveSearchState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}


// reducers para atualizar dados do paciente 
export const updateActiveSearchRequest = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ activeSearch: PotentialPatient }>) => {
    return { ...state, create: request({ ...state.create }) }
}

export const updateActiveSearchSuccess = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ data: PotentialPatient }>) => {
    const { data } = action.payload
    const updadedList = state.list.activeSearches.map((activeSearch) =>
        activeSearch.id === data.id ? data : activeSearch
    )
    return {
        ...state,
        create: success({ ...state.create, activeSearch: data }),
        list: { ...state.list, activeSearches: updadedList }
    }
}

export const updateActiveSearchFailure = (state: IActiveSearchState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}
// reducers para remover dados 
export const removeActiveSearchRequest = (state: IActiveSearchState = INITIAL_STATE, action: IActionType<{ activeSearchId: string }>) => {
    return { ...state, list: request({ ...state.list }) }
}

export const removeActiveSearchSuccess = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ activeSearchId: string }>) => {
    const { activeSearchId } = action.payload

    const updadedList = state.list.activeSearches.filter((activeSearch) =>
        activeSearch.id !== activeSearchId
    )
    return {
        ...state,
        list: success({ ...state.list, activeSearches: updadedList }),
        create: { ...state.create, activeSearch: new PotentialPatient() }
    }
}

export const removeActiveSearchFailure = (state: IActiveSearchState = INITIAL_STATE) => {
    return {
        ...state,
        list: failure(state.list)
    }
}
// reducers para remover dados 
export const rejectActiveSearchRequest = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ activeSearchId: string }>) => {
    return { ...state, list: request({ ...state.list }) }
}

export const rejectActiveSearchSuccess = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ activeSearchId: string }>) => {
    const { activeSearchId } = action.payload

    const updadedList = state.list.activeSearches.filter((activeSearch) =>
        activeSearch.id !== activeSearchId
    )
    return {
        ...state,
        list: success({ ...state.list, activeSearches: updadedList }),
        create: { ...state.create, activeSearch: new PotentialPatient() }
    }
}

export const rejectActiveSearchFailure = (state: IActiveSearchState = INITIAL_STATE) => {
    return {
        ...state,
        list: failure(state.list)
    }
}

export const promoteActiveSearchRequest = (state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ activeSearchId: string }>) => {
    return { ...state, create: request({ ...state.create }) }
}
export const promoteActiveSearchSuccess = (
    state: IActiveSearchState = INITIAL_STATE,
    action: IActionType<{ activeSearchId: string }>) => {
    const { activeSearchId } = action.payload
    const updadedList = state.list.activeSearches.filter((activeSearch) =>
        activeSearch.id !== activeSearchId
)
    return {
        ...state,
        create:  success({ ...state.create, activeSearch: new PotentialPatient()}),
        list:{ ...state.list, activeSearch: updadedList},
    }
}
export const promoteActiveSearchFailure = (state: IActiveSearchState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}
const reducer: Reducer<IActiveSearchState> = createReducer<IActiveSearchState>(INITIAL_STATE, {

    [ActiveSearchTypes.LOAD_ACTIVESEARCH_REQUEST]: loadActiveSearchRequest,
    [ActiveSearchTypes.LOAD_ACTIVESEARCH_SUCCESS]: loadActiveSearchSuccess,
    [ActiveSearchTypes.LOAD_ACTIVESEARCH_FAILURE]: loadActiveSearchFailure,
    [ActiveSearchTypes.FIND_ACTIVESEARCH_REQUEST]: findActiveSearchRequest,
    [ActiveSearchTypes.FIND_ACTIVESEARCH_SUCCESS]: findActiveSearchSuccess,
    [ActiveSearchTypes.FIND_ACTIVESEARCH_FAILURE]: findActiveSearchFailure,
    [ActiveSearchTypes.REMOVE_ACTIVESEARCH_REQUEST]: removeActiveSearchRequest,
    [ActiveSearchTypes.REMOVE_ACTIVESEARCH_SUCCESS]: removeActiveSearchSuccess,
    [ActiveSearchTypes.REMOVE_ACTIVESEARCH_FAILURE]: removeActiveSearchFailure,
    [ActiveSearchTypes.REJECT_ACTIVESEARCH_REQUEST]: rejectActiveSearchRequest,
    [ActiveSearchTypes.REJECT_ACTIVESEARCH_SUCCESS]: rejectActiveSearchSuccess,
    [ActiveSearchTypes.REJECT_ACTIVESEARCH_FAILURE]: rejectActiveSearchFailure,
    [ActiveSearchTypes.PROMOTE_ACTIVESEARCH_REQUEST]: promoteActiveSearchRequest,
    [ActiveSearchTypes.PROMOTE_ACTIVESEARCH_SUCCESS]: promoteActiveSearchSuccess,
    [ActiveSearchTypes.PROMOTE_ACTIVESEARCH_FAILURE]: promoteActiveSearchFailure,

    [ActiveSearchTypes.STORE_ACTIVESEARCH]: storeActiveSearch,
    [ActiveSearchTypes.HANDLE_DIALOG]: handleDialog,
    [ActiveSearchTypes.RESET_PAGINATOR]: resetPaginator
})
export default reducer    